module.exports = __webpack_public_path__ + "static/media/istart.1b33f959.png";